import CT from "../assets/images/procedures/imagin_img_1.jpg";

import densitometry from "../assets/images/procedures/imagin_img_9.jpg";

import MAMMOGRAPHY from "../assets/images/procedures/imagin_img_2.jpg";

import DIGITALXRAY from "../assets/images/procedures/imagin_img_4.jpg";

import ECHOCARDIOGRAPHY from "../assets/images/procedures/imagin_img_3.jpg";

import NUCLEARMEDICINE from "../assets/images/procedures/imagin_img_8.jpg";

import MRI from "../assets/images/procedures/imagin_img_6.jpg";

import PET from "../assets/images/procedures/imagin_img_5.jpg";

import ULTRASOUND from "../assets/images/procedures/imagin_img_7.jpg";

// Shaped Images for imagin services

import BoneShaped from "../assets/images/procedures/DEXA Scan.png";

import MAMMOGRAPHYShape from "../assets/images/procedures/3D Mammography.png";

import DIGITALXRAYShape from "../assets/images/procedures/Digital X-Ray.png";

import ECHOCARDIOGRAPHYShape from "../assets/images/procedures/Echocardiography.png";

import NUCLEARMEDICINEShape from "../assets/images/procedures/Nuclear Medicine.png";

import MRIShape from "../assets/images/procedures/open_mri.png";

import ULTRASOUNDShape from "../assets/images/procedures/Ultrasound.jpg";

import curver_ct from "../assets/images/procedures/curved_ct-01.png";

import curer_pet_ct from "../assets/images/procedures/pet_ct_curved-01.png";

// videos in every imaging services

import CTScanVdo from "../assets/video/0_Cancer_Mri_3840x2160.mp4";
import CTScanVdo2 from "../assets/video/6463471_Doctor_Hospital_1920x1080.mp4";

import dexz_vdo_1 from "../assets/video/dexz_vdo_1.mp4";

import d_manman_1 from "../assets/video/3d_manman_1.mp4";

import digital_xray_1 from "../assets/video/digital_xray_1.mp4";
import digital_xray_2 from "../assets/video/digital_xray_2.mp4";
import cardio_vdo_1 from "../assets/video/cardio_vdo_1.mp4";
// import cardio_vdo_2 from "../assets/video/cardio_vdo_2.mp4";
import nuclear_1 from "../assets/video/nuclear_1.mp4";
import high_mri_1 from "../assets/video/open_mri_vdo.mp4";
import ultrasound_1 from "../assets/video/ultrasound_1.mp4";
import mamography from "../assets/icons/Imaging-icon -BIG/mammogram.png";
import UltraSound from "../assets/icons/Imaging-icon -BIG/ultrasound.png";
import NuclearMedicine from "../assets/icons/Imaging-icon -BIG/nuclear_128.png";
import DEXA from "../assets/icons/Imaging-icon -BIG/DEXA.png";
import DigitalXRay from "../assets/icons/Imaging-icon -BIG/x-ray.png";
import Echocardiography from "../assets/icons/Imaging-icon -BIG/echocardiography.png";
import MRIIcon from "../assets/icons/Imaging-icon -BIG/new_mri_128.png";
import OpenCT from "../assets/icons/Imaging-icon -BIG/openCT.png";
import PETICON from "../assets/icons/Imaging-icon -BIG/ct-scan.png";
//menu Icons
import PETIcon from "../assets/icons/MenuIcons/pet_scan.png";
import OpenMRIIcon from "../assets/images/procedures/new_mri_64.png";
import MamographyIcon from "../assets/icons/MenuIcons/mammogram.png";
import LowDoseCTIcon from "../assets/icons/MenuIcons/ct-scan.png";
import DigitalXRayIcon from "../assets/icons/MenuIcons/x-ray.png";
import DEXAIcon from "../assets/icons/MenuIcons/DEXA.png";
import NuclearMedicineIcon from "../assets/icons/MenuIcons/nuclear_64.png";
import UltrasoundIcon from "../assets/icons/MenuIcons/ultrasound.png";
import EchocardiographyIcon from "../assets/icons/MenuIcons/echocardiography.png";

//Outline Illustrations

import xray_outline from "../assets/images/procedures/digital_outline.png";
import pet_outline from "../assets/images/procedures/pet_outline.png";
import cardio_outline from "../assets/images/procedures/cardio_outline.png";
import ultrasound_outline from "../assets/images/procedures/ultrasound_outline.png";
import dexa_outline from "../assets/images/procedures/dexa_outline.png";

const ProceduresData = [
  // 3D Mammography
  {
    seoTitle: "3D Mammography and Breast Cancer Ultrasound in Crystal River",
    seoDescription:
      "Get accurate breast screening in Crystal River with advanced 3D mammography and breast cancer ultrasound for early detection and precise women’s health imaging.",
    image: MAMMOGRAPHY,
    cta: {
      title: "Book your 3D Mammography today!",
      description:
        "Get the accurate and precise results with CDC’s expert radiologists using the advanced technologies used in mammography.",
    },
    icon: mamography,
    menuIcon: MamographyIcon,
    category: "tests",
    alt: "2D/3D Mammography",
    title: "2D/3D Mammography",
    subTitle: "A Precise View, A Confident You",
    slug: "3D-mammography",
    shapedImg: MAMMOGRAPHYShape,
    description:
      "3D mammography, also known as digital breast tomosynthesis, uses hundreds of low-dose X-ray images taken from different angles to create a layered, three-dimensional view of the breast. This advanced technology improves the detection of breast cancer, lowers the rate of false positives, and gives patients greater confidence in their results.",
    whatIs: {
      heading: "Why Early Detection Matters",
      text: `1 in 8 women will be diagnosed with breast cancer during her lifetime, making regular mammograms essential for early detection and timely treatment. 3D Mammogram detects even small cancers that might be hidden by dense tissue on a regular 2D mammogram. Chances of survival are greatly increased when breast cancer is found early, reinforcing the importance of getting a 3D Mammogram for comprehensive screening.`,
      video: d_manman_1,
    },

    preparation: {
      title: "Exam Preparation Guidelines",
      before: {
        title: "Before the Scan",
        description:
          "Prepare yourself for the accurate and safe 3D Mammography",
        points: [
          "For your convenience, please wear a two-piece outfit",
          "Do not use deodorant, powder, or perfume under the arm or breast area.",
          "Please bring your previous mammogram films from other facilities with you.",
        ],
      },
    },

    faqs: [
      {
        question: "How often should I have a mammogram?",
        answer:
          "Annual mammograms are generally recommended for women aged 40 and above. Your physician may adjust the schedule based on your personal health history and risk factors.",
      },
      {
        question: "Will the mammogram be painful?",
        answer:
          "The procedure is largely painless. You may feel brief compression of the breast, which is necessary to obtain clear and accurate images.",
      },
    ],
  },
  //Cardiac/General/ Nuclear Medicine

  {
    seoTitle: "Nuclear medicine scan at Critius Diagnostic in Crystal Riiver",
    seoDescription:
      "Citrus Diagnostic Center provides nuclear medicine scans, gallium and hepatobiliary imaging, bone scans, and nuclear stress tests for accurate early diagnosis.",
    image: NUCLEARMEDICINE,
    cta: {
      title: "Book Your Nuclear Medicine Scan Now",
      description:
        "At Citrus Diagnostic Center, we combine state-of-the-art technology with caring service. We collaborate with your doctor to make sure you get results that help guide your health decisions.",
    },
    icon: NuclearMedicine,
    menuIcon: NuclearMedicineIcon,
    category: "tests",
    alt: "Nuclear Medicine",
    title: "Cardiac/Body Nuclear Medicine",
    subTitle: "Molecular Insights for Early Detection",
    slug: "cardiac-general-nuclear-medicine",
    shapedImg: NUCLEARMEDICINEShape,
    description:
      "Nuclear medicine allows radiologists to evaluate not only the structure of organs but also how they function in real time. By using safe, low-dose radioactive tracers, this technique highlights biological processes that cannot be seen through conventional imaging, often detecting conditions at the earliest stages.",
    whatIs: {
      heading: "During the Scan",
      text: "The procedure begins with the administration of a tracer, usually through a small intravenous injection. Depending on the type of study, the tracer may need several minutes to a few hours to distribute within the body. Once ready, you will be positioned comfortably on a scanning table while either a PET/CT or SPECT scan is performed to capture detailed images for analysis.",

      video: nuclear_1,
    },
    preparation: {
      title: "Exam Preparation Guidelines",
      before: {
        title: "NUCLEAR MEDICINE TESTS",
        points: [
          "Drink plenty of water the day before and morning of the test.",
          "Do NOT wear jewelry or metallic objects.",
          "Please wear loose, comfortable clothing.",
          "Inform technologists if you are pregnant or breastfeeding.",
          "Inform technologists of any allergies to radiology contrast or medications, and of any major kidney disease.",
          "No special preparation is required for tests involving the bones, inflammatory, lymphatic, brain, renal and pulmonary systems.",
          "Tests involving the gastrointestinal system require fasting at least 6-8 hours before the test. Some scans require pre-medicating as preparation.",
          "Cardiac tests require fasting for at least 4 hours before the test and stress tests require no caffeine for 24 hours before the test.",
          "Thyroid tests may require stopping certain medications before the test.",
        ],
      },
    },
    faqs: [
      {
        question: "Are there any side effects from a nuclear medicine scan?",
        answer:
          "Side effects are extremely rare. Most patients experience no discomfort and feel completely normal following the procedure.",
      },
      {
        question: "Can I undergo a nuclear medicine scan during pregnancy?",
        answer:
          "If a scan is medically necessary, special precautions are implemented to ensure safety. In many cases, your physician may recommend alternative imaging methods to minimize risk.",
      },
    ],
  },

  {
    seoTitle: "X-Ray Imaging and Digital Radiography for Accurate Diagnosis",
    seoDescription:
      "Citrus Diagnostic Center provides advanced digital X-ray imaging for lungs, bones, and dental radiography, ensuring accurate, clear, and safe diagnostic results.",
    image: DIGITALXRAY,
    cta: {
      title: "Book your Digital X-ray today!",
      description:
        "Get the accurate and precise results with CDC’s expert radiologists using the advanced technologies used for digital X-ray.",
    },
    icon: DigitalXRay,
    menuIcon: DigitalXRayIcon,
    category: "tests",
    alt: "Digital X-Ray",
    title: "Digital X-Ray",
    subTitle: "Sharper images. Safer care. Faster results.",
    slug: "digital-xray",
    shapedImg: DIGITALXRAYShape,
    description:
      "Our advanced digital X-ray technology provides clear, precise images to help physicians diagnose injuries and conditions with confidence. Whether it’s a bone fracture, joint pain, chest infection, or dental concern, digital X-rays allow for quick evaluation and accurate treatment planning.",
    whatIs: {
      heading: "What is a Digital X-Ray?",
      text: `A digital X-ray is a modern imaging technique that replaces traditional film with advanced computer technology. This innovation allows us to capture sharper images in seconds, use less radiation, and instantly share results with your doctor. Digital X-rays not only improve accuracy but also make the entire process faster, safer, and more comfortable for patients.`,
      video: digital_xray_1,
    },
    howDoes: {
      heading: "Sharper X-rays for clear views",
      text: `It quickly evaluates bones, lungs, and joints when there’s injury, pain, swelling, or suspected infection, providing fast results for treatment and deciding if further imaging is necessary. It delivers clear images within minutes, helps confirm fractures, arthritis, pneumonia, and other common conditions, and supports follow‑up by comparing images over time. Because images are digital, teams can adjust contrast and zoom for detail, share securely with other providers, and minimize repeat exams.`,
      image: xray_outline,
    },

    whyCDC: {
      heading: "Choose Accurate Imaging and Convenient Service",
      points: [
        "Most reports are available within 24–48 hours.",
        "We follow strict FDA guidelines and use low-radiation techniques.",
        "Your scans are reviewed by board-certified specialists for reliable reports.",
        "Results are shared electronically with your referring physician for coordinated care.",
        "We offer economical pricing and accept most insurance policies, making quality imaging accessible to all.",
      ],
      video: digital_xray_2,
    },

    preparation: {
      title: "Exam Preparation Guidelines",
      before: {
        title: "Before the scan",

        points: ["Do not wear jewelry or clothing containing metal."],
      },
    },

    faqs: [
      {
        question: "Are repeat X-rays safe if needed?",
        answer: `Yes. Because radiation exposure is minimal, repeat imaging can be safely performed when medically necessary.`,
      },
      {
        question: "How is digital X-ray different from traditional X-ray?",
        answer:
          "Digital X-rays produce immediate, high-resolution images that can be enhanced or zoomed in electronically, reducing the need for repeat scans and minimizing radiation exposure.",
      },
    ],
  },

  // Echocardiography
  {
    seoTitle: "Echocardiography and Cardiac Ultrasound at Citrus Center",
    seoDescription:
      "Get accurate heart scanning with echocardiography, cardiac PET, and transthoracic echo at Citrus Diagnostic Center for precise and complete cardiac evaluation.",
    image: ECHOCARDIOGRAPHY,
    cta: {
      title: "Schedule your Echocardiography Scan today!",
      description:
        "Get the accurate and precise results with CDC’s expert radiologists using the advanced echocardiography scanners",
    },
    icon: Echocardiography,
    menuIcon: EchocardiographyIcon,
    category: "tests",
    alt: "Echocardiography",
    title: "Echocardiography",
    subTitle: "Advanced heart imaging for precise diagnosis",
    slug: "echocardiography",
    shapedImg: ECHOCARDIOGRAPHYShape,
    introSlogan: "Clear, Precise, and Painless Heart Health Monitoring",
    description:
      "Echocardiography is a noninvasive, painless test that uses ultrasound technology to provide detailed, real-time views of the heart. It allows physicians to assess the heart’s chambers, valves, motion and blood flow with accuracy, making it an essential tool in diagnosing and managing cardiovascular conditions.",
    whatIs: {
      video: cardio_vdo_1,
    },
    howDoes: {
      image: cardio_outline,
    },
    benefits: {
      title: "Why Echocardiography",
      points: [
        "Detects structural and functional abnormalities of the heart.",
        "Evaluates valve disorders, pumping efficiency and blood circulation.",
        "Safely monitors chronic heart conditions over time, without exposure to radiation.",
        "Assists in treatment planning for symptoms such as chest pain, shortness of breath or suspected heart failure.",
      ],
    },

    preparation: {
      title: "Exam Preparation Guidelines",
      before: {
        title: "Before the test",
        description: "Get prepared for your Echocardiography scanning",
        points: [
          "You will have to wear comfortable clothes.",
          "You may be asked by your doctors to fast for 4-6 hours before the scan.",
          "If the thin tube is used, then you might feel a sore throat, which usually disappears after a few hours.",
          "If you're on any medications, then your doctors will adjust the medicine, especially if you are taking drugs for blood pressure or the heart.",
        ],
      },
    },
    faqs: [
      {
        question:
          "Can anxiety or nervousness impact my echocardiography results?",
        answer:
          "In most cases, anxiety does not affect the accuracy of the test. If you have concerns, it is advisable to discuss them with your physician beforehand.",
      },
      {
        question: "Can echocardiography detect valve problems?",
        answer:
          "Yes. The test allows physicians to visualize heart valves in motion, detect narrowing or leakage, and assess the severity of valve-related conditions.",
      },
    ],
  },

  //Breast/General/Vascular Untrasound

  {
    seoTitle: "Ultrasound and Abdominal Scan at Citrus Diagnostic Center",
    seoDescription:
      "Ultrasound scan, vascular ultrasound and abdominal sonogram at Citrus Diagnostic Center provide accurate diagnostic sonography for reliable health evaluation.",
    image: ULTRASOUND,
    cta: {
      title: "Schedule your Ultrasound Scan today!",
      description:
        "Get the accurate and precise results with CDC’s expert radiologists using the advanced Ultrasound techniques.",
    },
    icon: UltraSound,
    menuIcon: UltrasoundIcon,
    category: "tests",
    alt: "Ultrasound",
    title: "General/Vascular Ultrasound",
    subTitle: "See through Sound",
    slug: "ultrasound",
    shapedImg: ULTRASOUNDShape,
    description:
      "Ultrasound is one of the safest and most versatile imaging methods in modern medicine. Using high-frequency sound waves, it provides real-time views of organs, tissues, blood flow and pregnancies—all without the use of radiation. This makes it suitable for patients of all ages, including children and expectant mothers.",
    whatIs: {
      video: ultrasound_1,
    },
    howDoes: {
      image: ultrasound_outline,
    },

    benefits: {
      title: "Benefits Of Ultrasound",
      points: [
        "Provides dynamic imaging of blood flow in real time, helping identify blockages, clots, or narrowing before symptoms become severe.",
        "Enables precise monitoring after vascular procedures, ensuring grafts, stents, or repairs remain functional over time.",
        "Offers early insights into subtle changes in tissue or vessel health, supporting proactive care decisions.",
        "Safe for repeated follow-up examinations, making it reliable for managing chronic vascular conditions.",
        "Conducted with advanced ultrasound platforms and interpreted by subspecialized radiologists for consistently high diagnostic accuracy.",
      ],
    },
    preparation: {
      title: "Exam Preparation Guidelines",
      before: {
        title: "ABDOMEN/DOPPLER/GALLBLADDER ULTRAOUND",

        points: [
          "Do not eat or drink anything for six (6) hours before your exam.",
        ],
      },
      during: {
        title: "BLADDER/PELVIC ULTRASOUND ",
        points: [
          "2 hours before your test: Empty your bladder.",
          "1 hour before your test: Drink at least 32 ounces of water (4 cups).",
          "Your bladder must be full for this test. Do not urinate before the test.",
        ],
      },
      after: {
        title: "OTHER ULTRASOUND TESTS:",
        points: ["No preparation required"],
      },
    },
    faqs: [
      {
        question:
          "Will the gel used during the ultrasound cause an allergic reaction?",
        answer:
          "The gel is water-based and hypoallergenic, making allergic reactions extremely rare.",
      },
      {
        question: "Can I undergo multiple ultrasound examinations?",
        answer:
          "Yes. Ultrasound is a safe, non-invasive technique and can be repeated as often as medically necessary, following your physician’s recommendations.",
      },
    ],
  },

  // MRI/HIGH MRI Scans
  {
    seoTitle: "Open MRI and Imaging Center | Citrus Diagnostic Center ",
    seoDescription:
      "Experience precise diagnostics at Citrus Diagnostic Center, a trusted MRI center offering advanced open MRI and imaging services for safe and comfortable scans.",
    image: MRI,
    icon: MRIIcon,
    menuIcon: OpenMRIIcon,
    category: "tests",
    alt: "MRI",
    title: "High-Field/Open MRI",
    subTitle: "See More and Worry Less",
    slug: "open-mri-scan",
    shapedImg: MRIShape,
    introSlogan:
      "Experience the accurate and comfortable imaging diagnosis with our MRI scan",
    description:
      "At Citrus Diagnostic Center (CDC), we understand that MRI scans can be daunting. Our cutting-edge High Field and Open MRI tech provides precise results while making the process smooth and relaxing. Patients dealing with ongoing pain, injury from sport, or neurological concerns benefit from precise problem identification to initiate the most appropriate treatment plan",
    whatIs: {
      heading: "What is High Field/Open MRI?",
      text: `Magnetic Resonance Imaging (MRI) is a safe, non-invasive method that uses magnetic fields, radio waves, and computer processing to capture highly detailed images of the body’s internal structures. It provides clear, radiation-free views of soft tissues in the brain, spine, joints, heart, and abdominal organs, helping doctors detect concerns early and plan treatment with precision.`,
      video: high_mri_1,
    },

    preparation: {
      title: "Exam Preparation Guidelines",
      before: {
        title: "MRI",

        points: [
          "Nothing to eat or drink except water 4 hours before the test.",
          "Drink plenty of water the day before and morning of the test.",
          "You will be asked to change into a gown for the test.",
          "Please leave all jewelry and metal objects at home.",
          "Inform technologists of any allergies to radiology contrast or medications.",
          "Women should inform technologists if there is any possibility of pregnancy.",
        ],
      },
      during: {
        title: "PROSTATE/RECTAL/MR ENTEROGRAPHY",

        points: [
          "Nothing to eat or drink except water 4 hours before the test.",
          "Drink plenty of water the day before and morning of the test.",
          "You will be asked to change into a gown for the test.",
          "Please leave all jewelry and metal objects at home.",
          "Inform technologists of any allergies to radiology contrast or medications.",
          "Drink 10 oz bottle of magnesium citrate the night before the test.",
          "Take (4) tablets of Dulcolax the night before the test.",
          "Start a clear liquid diet the night before the test.",
          "No coffee on the day of the test.",
        ],
      },
    },

    faqs: [
      {
        question:
          "What happens if I cannot remain completely still during the MRI scan?",
        answer:
          "Remaining still is essential to obtain clear images, as even minor movement can blur results. Our skilled technicians will guide and support you throughout the scan to ensure accuracy.",
      },
      {
        question: "Is it okay if I fall asleep during the MRI?",
        answer:
          "Yes. Falling asleep during the MRI is perfectly safe. Many patients find the environment calming and may naturally doze off during the procedure.",
      },
    ],

    cta: {
      title: "Book Your MRI Now",
      description:
        "At Citrus Diagnostic Center, we want your imaging experience to be easy and stress-free. Our advanced MRI equipment, caring staff and expert radiologists make sure you feel supported while getting the answers you need.",
    },
  },
  // Low Dose 160-Slice Open CT
  {
    seoTitle: "Open CT Scanner, Low Dose CT Scan and Lung Cancer Screening",
    seoDescription:
      "Open CT scanner and low dose CT scan help in early lung cancer screening ensuring high-quality imaging, minimal radiation, and accurate diagnostic results.",
    image: CT,
    cta: {
      title: "Schedule your CT Scan today!",
      description:
        "At Citrus Diagnostic Center, we use advanced CT technology along with caring support to provide fast reports. Our team is here to help, whether you need heart scans, an injury check-up, or answers to general health questions.",
    },
    icon: OpenCT,
    menuIcon: LowDoseCTIcon,
    category: "tests",
    alt: "CT Scan",
    title: "Low Dose 160-Slice Open CT",
    subTitle: "Efficient, Precise Imaging with Patient Comfort in Mind",
    slug: "low-dose-open-ct-scan",
    shapedImg: curver_ct,

    description:
      "Our 160-slice open CT scanner by Cleerly AI delivers high-resolution imaging in seconds while using up to 40% less radiation than conventional CT systems. Its open design reduces claustrophobia and noise anxiety, allowing patients to complete scans with greater ease. It provides results quickly and reliably, with reports available in 24–48 hours.",
    whatIs: {
      video: CTScanVdo,
    },

    whyCDC: {
      video: CTScanVdo2,
    },
    preparation: {
      title: "Exam Preparation Guidelines",
      before: {
        title: "CT/NON-CARDIAC CTA",
        points: [
          "Nothing to eat or drink except water 4 hours before the test if it is ordered with IV contrast.",
          "Drink plenty of water the day before and morning of the test.",
          "Do NOT wear jewelry. Metallic objects such as jewelry, glasses, hearing aids, piercings, dental devices and metal containing bras may affect the quality of the test.",
          "Please wear loose comfortable clothing.",
          "Inform technologists of any allergies to radiology contrast or medications, and of any major kidney disease.",
          "Women should inform technologists if there is any possibility of pregnancy.",
          "Do NOT take Metformin on the day of the test and for two days after the test if ordered with IV contrast. Please contact your referring physician if you have questions about your diabetic medications.",
        ],
      },
      after: {
        title: "CARDIAC CTA (CORONARY ARTERIES):",
        description: "Fasten you recovery with follow-up care",
        points: [
          "Nothing to eat or drink except water 4 hours before the test if it is ordered with IV contrast.",
          "Drink plenty of water the day before and morning of the test.",
          "No caffeine 12 hours before your test.",
          "Take all medications as usual except Viagra/Cialis/other performance enhancing drugs. If you take blood pressure medicine at night, please take it in the morning instead. Please bring a list of medications to your test.",
          "Please get the required medications needed to lower your heart rate from your referring doctor before the test.",
          "Do NOT wear jewelry. Metallic objects such as jewelry, glasses, hearing aids, piercings, dental devices and metal containing bras may affect the quality of the test.",
          "Please wear loose, comfortable clothing.",
          "Inform technologists if you have severe asthma or use inhalers for breathing problems.",
          "Inform technologists of any allergies to radiology contrast or medications, and of any major kidney disease.",
          "Women should inform technologists if there is any possibility of pregnancy.",
          "Do NOT take Metformin on the day of the test and for two days after the test if ordered with IV contrast. Please contact your referring physician if you have questions about your diabetic medications.",
        ],
      },
    },

    faqs: [
      {
        question: "Are CT scans appropriate for children?",
        answer: `CT scans can be performed for pediatric patients, but only when absolutely necessary. Physicians typically consider alternative imaging methods first to minimize exposure.`,
      },
      {
        question: "Is it safe to undergo a CT scan during pregnancy?",
        answer:
          "It is essential to inform your physician if you are pregnant. CT scans are generally avoided during pregnancy, and safer alternatives, such as ultrasound or MRI, are recommended whenever possible.",
      },
    ],
  },

  //DEXA/DXA (Bone Desnity Scan)
  {
    seoTitle: "Bone Density Scan DEXA Body Scan Osteoporosis Screening",
    seoDescription:
      "DEXA scan, bone density scan and body fat scan provide precise results to assess bone health, body composition and detect early osteoporosis signs effectively.",
    image: densitometry,
    cta: {
      title: "Schedule your Bone Density Scan today!",
      description:
        "Get the accurate and precise results with CDC’s expert radiologists using the advanced technologies for analysis of your bone health.",
    },
    icon: DEXA,
    menuIcon: DEXAIcon,
    category: "tests",
    alt: "DEXA/DXA (Bone Desnity Scan)",
    title: "Osteoporosis DEXA Scan",
    subTitle: "Quick, safe scans for stronger bones",
    slug: "dexa-bone-desnity-scan",
    shapedImg: BoneShaped,
    description:
      "At CDC, we know that maintaining bone strength is vital for long-term health, particularly as age, lifestyle or medical conditions can increase the risk of bone loss. A DEXA scan (Dual-Energy X-ray Absorptiometry) is a simple, painless and noninvasive test that measures bone density with precision. Unlike standard X-rays, which only reveal changes after a fracture, a DEXA scan can identify even early thinning of the bones—helping to prevent complications before they occur.",
    whatIs: {
      heading: "What is a DEXA Scan ",
      text: `A DEXA scan evaluates bone density in areas most prone to fracture, including the spine, hip, and forearm. It is the international standard for diagnosing osteoporosis and osteopenia, providing clarity on bone health so your physician can recommend the right care.`,
      video: dexz_vdo_1,
    },
    howDoes: {
      heading: "DEXA at CDC",
      text: `Our advanced imaging systems deliver clear and reliable results, interpreted by experienced radiologists with attention to accuracy and detail. Reports are delivered promptly, enabling timely medical decisions. With insurance acceptance and accessible pricing, we make it easier to prioritize your bone health without delay.`,
      image: dexa_outline,
    },

    preparation: {
      title: "Exam Preparation Guidelines",
      before: {
        title: "Before the Scan",
        description: "Prepare yourself for accurate and safe scanning",
        points: [
          "Do not take calcium supplements within 24 hours before your test.",
          "Wear comfortable clothing without metal, buttons or zippers.",
          "If you had a CT or X-Ray test with IV or oral contrast, schedule your DEXA 7 days after the CT or X-Ray test was performed.",
          "If you had a recent Nuclear Medicine test, schedule your DEXA at least 7 days after the Nuclear Medicine test was performed.",
        ],
      },
    },
    benefits: {
      title: "Key Benefits",
      points: [
        "Detects bone loss before fractures develop.",
        "Provides accurate diagnosis of osteoporosis and osteopenia.",
        "Monitors treatment response and tracks progress over time.",
      ],
    },

    faqs: [
      {
        question: "How often should I have a DEXA scan?",
        answer: `The frequency depends on your age, bone health, and risk factors. Typically, most adults undergo a scan every 2–3 years, though your physician may recommend a different schedule based on your individual needs.
`,
      },
      {
        question: " Is the DEXA scan covered by insurance?",
        answer: `Yes, most major medical insurance plans are accepted. Our staff can provide guidance on coverage details and assist with any necessary approvals.`,
      },
    ],
  },

  // PET/CT Scans
  {
    seoTitle: "PET CT Scan and PSMA Imaging at Citrus Diagnostic Center",
    seoDescription:
      "Citrus Diagnostic Center provides advanced PET CT and PSMA scans for accurate cancer detection and brain imaging, ensuring clear results and early diagnosis.",
    image: PET,
    icon: PETICON,
    menuIcon: PETIcon,
    category: "tests",
    alt: "PET/CT",
    title: "PET/CT",
    subTitle: "One scan for detailed insights",
    slug: "pet-ct-scan",
    shapedImg: curer_pet_ct,
    introSlogan: "Power of two scan in one clear answer",
    description:
      "PET/CT, is an advanced hybrid imaging technology that combines Positron Emission Tomography (PET) with Computed Tomography (CT). This integration provides both functional and anatomical detail, making it one of the most powerful modalities for detecting cancer, evaluating organ function, and guiding precise treatment decisions when traditional imaging alone is not sufficient.",
    whatIs: {
      heading: "Safe and Reliable Imaging",
      subtitle: "",
      text: "The tracer used in PET imaging carries a very low level of radioactivity and is FDA approved. It is naturally eliminated from the body, most often through urine, and adverse reactions are rare. This makes PET/CT a safe and well-tolerated option for patients needing answers about their health.",
      video: CTScanVdo,
    },
    howDoes: {
      heading: "Faster Scans. Lower Dose.",
      text: `With modern PET/CT technology, scans are quicker — often completed in as little as 10–15 minutes — and require a lower tracer dose compared to older systems. This combination reduces patient exposure while delivering high-quality results, making it possible to scan more efficiently without sacrificing accuracy.`,
      image: pet_outline,
    },
    paragraphtwo: {
      title: "What Radiologists See",
      subtitle: "",
      description:
        "A PET/CT exam gives radiologists the advantage of viewing both structural and metabolic information together. A lymph node, for example, may look normal in size on CT, but abnormal metabolic activity on PET could indicate disease. This dual approach helps detect cancer, inflammation, and other abnormalities with greater confidence.",
    },
    paragraphthree: {
      title: "Detection Beyond Cancer ",
      subtitle: "",
      description:
        "While PET/CT is widely known for its role in oncology — identifying tumors, staging cancer, and monitoring treatment — its uses extend much further. PET/CT is increasingly important in evaluating neurological conditions, heart disease, and other disorders where understanding how tissues function is as critical as knowing their structure.",
    },
    cta: {
      title: "Schedule your PET/CT Scan today!",
      description: "Schedule your PET/CT Scan today!",
    },
    preparation: {
      title: "Exam Preparation Guidelines",
      before: {
        title: "PET/CT (FDG)",
        description: "Prepare yourself for the accurate and safe imaging",
        points: [
          "Nothing to eat or drink except water 4 hours before the test.",
          "Drink plenty of water the day before and morning of the test.",
          "No exercise 24 hours before the test.",
          "Do NOT wear jewelry. Metallic objects such as jewelry, glasses, hearing aids, piercings, dental devices, and metal containing bras may affect the quality of the test.",
          "Please wear loose, comfortable clothing.",
          "Inform technologists of any allergies to radiology contrast or medications, and of any major kidney disease.",
          "Women should inform technologists if there is any possibility of pregnancy.",
          "This 2-part test takes 1.5–2 hours (Part 1: Injection / Part 2: Pictures).",
        ],
      },
      during: {
        title: "BONE PET/CT (F18 FLUORIDE)",
        description: "When the actual scan begins",
        points: [
          "Drink plenty of water the day before and morning of the test.",
          "Do NOT wear jewelry. Metallic objects such as jewelry, glasses, hearing aids, piercings, dental devices, and metal containing bras may affect the quality of the test.",
          "Please wear loose, comfortable clothing.",
          "Inform technologists of any allergies to radiology contrast or medications, and of any major kidney disease.",
          "Women should inform technologists if there is any possibility of pregnancy.",
          "This 2-part test takes 1.5–2 hours (Part 1: Injection / Part 2: Pictures).",
        ],
      },
      after: {
        title:
          "PET/CT NEUROENDOCRINE SOMATOSTATIN RECEPTOR (NETSPOT)-PET/CT PROSTATE PSMA (POSLUMA)",
        description: "Important follow-up tips after the scan",
        points: [
          "Drink plenty of water the day before and morning of the test.",
          "Do NOT wear jewelry. Metallic objects such as jewelry, glasses, hearing aids, piercings, dental devices, and metal containing bras may affect the quality of the test.",
          "Please wear loose, comfortable clothing.",
          "Inform technologists of any allergies to radiology contrast or medications, and of any major kidney disease.",
          "Women should inform technologists if there is any possibility of pregnancy.",
          "This 2-part test takes 1.5–2 hours (Part 1: Injection / Part 2: Pictures).",
        ],
      },
    },

    faqs: [
      {
        question:
          "Does the radioactive material used in the scan pose any risk?",
        answer:
          "The radioactive material used is safe. At CDC, it is administered in very low amounts and is naturally eliminated from the body within a few hours after the test.",
      },
      {
        question: "Will I need someone to accompany me?",
        answer:
          "Generally, patients can attend alone, but those needing assistance or sedation may require a companion.",
      },
    ],
  },

  // Digital X-Ray Scan
];
export default ProceduresData;
